
<div class="w-100 h-100 fix-parent-height-center-center" *ngIf="loadingCustomData">
  <span class="loader"></span>
</div>

<section class="position-relative animated fadeIn">
  <mat-card appearance="outlined" style="width: 310px; border: 0; margin: 0 auto; padding: 0px 0px" *ngIf="!loadingCustomData" class="bg-white">
    <!-- CUSTOM TITLE -->
    <mat-card-header
      class="p-3 d-flex flex-column justify-content-center align-content-center"
      *ngIf="!loadingCustomData">
      <mat-card-title *ngIf="!!customImgSrc || !!customText" class="m-0 text-center pb-2 px-3">
        <img
          *ngIf="!!customImgSrc"
          class="custom-login-img-responsive d-inline-block align-top"
          [src]="customImgSrc | domSanitizer: 'url'"
          [alt]="'LOGIN.LOGOS.CLIENT-ALT' | translate" />
        <div *ngIf="!!customText" class="h4 m-0 pt-2 text-center">
          {{ customText }}
        </div>
      </mat-card-title>
      <!-- DEFAULT TITLE -->
      <mat-card-title class="m-0 text-center">
        <img *ngIf="theme === 'Redtrust'" src="assets/images/logo/{{theme}}/logo-color.svg" height="50" class="d-inline-block align-top" [alt]="'LOGIN.LOGOS.REDTRUST-ALT' | translate:{ theme: theme }">
      </mat-card-title>
    </mat-card-header>

    <!-- USER PIN CONFIG -->
    <mat-card-content class="" *ngIf="loginStep === 'configUserPin'">
      <!-- SET & RESET USER PIN -->
      <div class="w-100 pb-2">
        <div class="w-100 row mx-0">
          <div class="col-12 px-0 py-2 text-center">
            <span class="h5" *ngIf="nextStep === 'SetPin'">
              {{ 'GLOBAL.SET-USER-PIN-TITLE' | translate }}
            </span>
            <span class="h5" *ngIf="nextStep === 'RecoverPin'">
              {{ 'GLOBAL.RESET-USER-PIN-TITLE' | translate }}
            </span>
          </div>
        </div>
        <!-- No SAML2 && No OAuth2 -->
        <div class="w-100" *ngIf="userPinConfig.dt !== 'SAML2' && userPinConfig.dt !== 'OAuth2'">
          <div class="row mx-0" [formGroup]="normalUserPinFormGroup" #normalUserPinForm="ngForm">
            <div class="col-12 px-0 pb-2">
              <mat-label class="w-100 d-block h6 mb-0">
                {{ 'GLOBAL.ACCOUNT-EDIT-NEW-USER-PIN' | translate }} *
              </mat-label>
              <mat-form-field class="w-100">
                <input matInput required [type]="hideUserPinNew ? 'password' : 'text'" [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-USER-PIN' | translate" formControlName="newPin" />
                <i class="rt-icon pointer fs22 mx-1" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hideUserPinNew = !hideUserPinNew" [ngClass]="{'rt-view': hideUserPinNew, 'rt-hide': !hideUserPinNew}"></i>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="normalUserPinForm.invalid && (normalUserPinForm.dirty || normalUserPinForm.touched)">
                  <small *ngIf="normalNewPin.errors?.['required']">
                    {{ 'GLOBAL.ERRORS.REQUIRED' | translate }}
                  </small>
                  <small *ngIf="(normalNewPin.errors?.['minlength'] || normalNewPin.errors?.['maxlength']) && !(normalUserPinForm.errors?.fieldsDontMatch)">
                    {{ 'GLOBAL.ERRORS.PIN-LENGTH' | translate }}
                  </small>
                  <small *ngIf="normalUserPinForm.errors?.fieldsDontMatch && !(normalNewPin.errors?.['minlength'] && normalNewPin.errors?.['maxlength'])">
                    {{ 'LOGIN.FORM.PIN-DONT-MATCH' | translate }}
                  </small>
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 pb-2">
              <mat-label class="w-100 d-block h6 mb-0">
                {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-USER-PIN' | translate }} *
              </mat-label>
              <mat-form-field class="w-100">
                <input matInput required [type]="hideUserPinRepeat ? 'password' : 'text'" [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-USER-PIN' | translate" formControlName="newPinConfirm" (keyup.enter)="createUserPin()"/>
                <i class="rt-icon pointer fs22 mx-1" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hideUserPinRepeat = !hideUserPinRepeat" [ngClass]="{'rt-view': hideUserPinRepeat, 'rt-hide': !hideUserPinRepeat}"></i>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="normalUserPinForm.invalid && (normalUserPinForm.dirty || normalUserPinForm.touched)">
                  <small *ngIf="normalNewPinConfirm.errors?.['required']">
                    {{ 'GLOBAL.ERRORS.REQUIRED' | translate }}
                  </small>
                  <small *ngIf="(normalNewPinConfirm.errors?.['minlength'] || normalNewPinConfirm.errors?.['maxlength']) && !(normalUserPinForm.errors?.fieldsDontMatch)">
                    {{ 'GLOBAL.ERRORS.PIN-LENGTH' | translate }}
                  </small>
                  <small *ngIf="normalUserPinForm.errors?.fieldsDontMatch && !(normalNewPinConfirm.errors?.['minlength'] && normalNewPinConfirm.errors?.['maxlength'])">
                    {{ 'LOGIN.FORM.PIN-DONT-MATCH' | translate }}
                  </small>
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- SAML2 || OAuth2 -->
        <div class="w-100" *ngIf="userPinConfig.dt === 'SAML2' || userPinConfig.dt === 'OAuth2'">
          <div class="row mx-0" *ngIf="!alreadySendCode">
            <div class="w-100">
              <div class="w-100 row mx-0 pt-2">
                <div class="alert-info wb-ball border-radius-20px p-3">
                  <span class="d-inline-block w-100 text-justify">
                    <span class="d-inline-block w-100">
                      {{ 'GLOBAL.SEND-EMAIL-CODE' | translate }}
                    </span>
                  </span>
                </div>
                <div class="w-100 pt-3 text-center">
                  <button mat-raised-button color="primary" class="" [disabled]="sendingPin || sendingPinCode" (click)="sendPinCode()">
                    <i class="rt-icon rt-confirm" *ngIf="isMobile"></i>
                    <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPinCode"></i>
                    <span *ngIf="!isMobile">{{ 'GLOBAL.SEND-CODE' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0" [formGroup]="codeUserPinFormGroup" #codeUserPinForm="ngForm" *ngIf="alreadySendCode">

            <div class="col-12 px-0 pb-2 mat-input-group-btn-left">
              <mat-label class="w-100 d-block h6 mb-0">
                <span class="d-inline-block fw-bolder">
                  {{ 'GLOBAL.ACCOUNT-EDIT-AUTH-CODE' | translate }} *
                </span>
                <span class="d-inline-block line-none vertical-align-middle">
                  <i class="rt-icon rt-info pointer ms-2" #tooltip="matTooltip" matTooltipPosition="below" [matTooltip]="'GLOBAL.PIN-CODE-INFO' | translate " (click)="tooltip.show()"></i>
                </span>
              </mat-label>
              <mat-form-field class="">
                <input matInput required type="text" [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-CODE-USER-PIN' | translate" formControlName="code" />
                <mat-hint class="text-danger animated fadeInDown" *ngIf="codeUserPinForm.invalid && (codeUserPinForm.dirty || codeUserPinForm.touched)">
                  <small *ngIf="code.errors?.['required']">
                    {{ 'GLOBAL.ERRORS.REQUIRED' | translate }}
                  </small>
                </mat-hint>
              </mat-form-field>
              <button class="mat-input-group-btn" mat-stroked-button color="primary" [disabled]="sendingPin || sendingPinCode || (countDown | async) > 0" (click)="resendPinCode()">
                <i class="rt-icon rt-confirm" *ngIf="isMobile"></i>
                <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPinCode"></i>
                <small *ngIf="!isMobile && (countDown | async) <= 0">
                  {{ 'GLOBAL.RESEND-CODE' | translate }}
                </small>
                <small *ngIf="!isMobile && (countDown | async) > 0">
                  {{ countDown | async }} {{ 'GLOBAL.SEC' | translate }}
                </small>

              </button>
            </div>
            <div class="col-12 px-0 pb-2">
              <mat-label class="w-100 d-block h6 mb-0">
                {{ 'GLOBAL.ACCOUNT-EDIT-NEW-USER-PIN' | translate }} *
              </mat-label>
              <mat-form-field class="w-100">
                <input matInput required [type]="hideUserPinNew ? 'password' : 'text'" [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-NEW-USER-PIN' | translate" formControlName="newPin" />
                <i class="rt-icon pointer fs22 mx-1" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-new-pin'" (click)="hideUserPinNew = !hideUserPinNew" [ngClass]="{'rt-view': hideUserPinNew, 'rt-hide': !hideUserPinNew}"></i>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="codeUserPinForm.invalid && (codeUserPinForm.dirty || codeUserPinForm.touched)">
                  <small *ngIf="codeNewPin.errors?.['required']">
                    {{ 'GLOBAL.ERRORS.REQUIRED' | translate }}
                  </small>
                  <small *ngIf="(codeNewPin.errors?.['minlength'] || codeNewPin.errors?.['maxlength']) && !(codeUserPinForm.errors?.fieldsDontMatch)">
                    {{ 'GLOBAL.ERRORS.PIN-LENGTH' | translate }}
                  </small>
                  <small *ngIf="codeUserPinForm.errors?.fieldsDontMatch && !(codeNewPin.errors?.['minlength'] && codeNewPin.errors?.['maxlength'])">
                    {{ 'LOGIN.FORM.PIN-DONT-MATCH' | translate }}
                  </small>
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 pb-2">
              <mat-label class="w-100 d-block h6 mb-0">
                {{ 'GLOBAL.ACCOUNT-EDIT-REPEAT-NEW-USER-PIN' | translate }} *
              </mat-label>
              <mat-form-field class="w-100">
                <input
                  matInput
                  required
                  [type]="hideUserPinRepeat ? 'password' : 'text'"
                  [placeholder]="'GLOBAL.ACCOUNT-EDIT-INSERT-REPEAT-NEW-USER-PIN' | translate"
                  formControlName="newPinConfirm" (keyup.enter)="codeUserPin()"/>
                <i class="rt-icon pointer fs22 mx-1" aria-label="Show/Hide pin" matSuffix [attr.data-selenium]="'toggle-repeat-new-pin'" (click)="hideUserPinRepeat = !hideUserPinRepeat" [ngClass]="{'rt-view': hideUserPinRepeat, 'rt-hide': !hideUserPinRepeat}"></i>
                <mat-hint class="text-danger animated fadeInDown" *ngIf="codeUserPinForm.invalid && (codeUserPinForm.dirty || codeUserPinForm.touched)">
                  <small *ngIf="codeNewPinConfirm.errors?.['required']">
                    {{ 'GLOBAL.ERRORS.REQUIRED' | translate }}
                  </small>
                  <small *ngIf="(codeNewPinConfirm.errors?.['minlength'] || codeNewPinConfirm.errors?.['maxlength']) && !(codeUserPinForm.errors?.fieldsDontMatch)">
                    {{ 'GLOBAL.ERRORS.PIN-LENGTH' | translate }}
                  </small>
                  <small *ngIf="codeUserPinForm.errors?.fieldsDontMatch && !(codeNewPinConfirm.errors?.['minlength'] && codeNewPinConfirm.errors?.['maxlength'])">
                    {{ 'LOGIN.FORM.PIN-DONT-MATCH' | translate }}
                  </small>
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-inline-block text-center">
        <button mat-raised-button *ngIf="userPinConfig.dt !== 'SAML2' && userPinConfig.dt !== 'OAuth2'" type="submit" color="primary" class="" [disabled]="!normalUserPinFormGroup.valid || sendingPin" (click)="createUserPin()">
          <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPin"></i>
          <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingPin"></i>
          <span *ngIf="!isMobile && !sendingPin">{{ 'GLOBAL.CONTINUE' | translate }}</span>
        </button>
        <button mat-raised-button *ngIf="(userPinConfig.dt === 'SAML2' || userPinConfig.dt === 'OAuth2') && alreadySendCode" type="submit" color="primary" class="" [disabled]="!codeUserPinFormGroup.valid || sendingPin || sendingPinCode" (click)="codeUserPin()">
          <i class="fas fa-spinner fa-pulse fa-1x me-2" *ngIf="sendingPin"></i>
          <i class="rt-icon rt-disquete" *ngIf="isMobile && !sendingPin"></i>
          <span *ngIf="!isMobile && !sendingPin">{{ 'GLOBAL.CONTINUE' | translate }}</span>
        </button>
      </div>
    </mat-card-content>

    <!-- FINISH SUCCESS -->
    <mat-card-content class="" *ngIf="loginStep === 'finish'">
      <!-- next implement -->
      <div class="w-100">
        <div class="w-100 row mx-0">
          <div class="alert-success wb-ball border-radius-20px p-3">
            <span class="d-inline-block w-100 h6 py-2 text-center">
              <span *ngIf="nextStep === 'SetPin'">
                {{ 'GLOBAL.SET-USER-PIN-FINISH' | translate }}
              </span>
              <span *ngIf="nextStep === 'RecoverPin'">
                {{ 'GLOBAL.RESET-USER-PIN-FINISH' | translate }}
              </span>
            </span>
            <span class="d-inline-block w-100 text-center">
              {{ 'GLOBAL.USER-PIN-CONFIG-FINISH' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="w-100 pt-3 text-center">
        <button mat-stroked-button color="primary" class="" [disabled]="sendingPin" (click)="redirectPersonal()">
          <i class="rt-icon rt-casa" *ngIf="isMobile"></i>
          <span *ngIf="!isMobile">{{ 'GLOBAL.GO-PERSONAL-AREA' | translate }}</span>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</section>
